// extracted by mini-css-extract-plugin
export default {"statistics":"StaffingLevelsDashboard_statistics__V6RYp","statistics__dashboard":"StaffingLevelsDashboard_statistics__dashboard__qkEN1"};